import Bridge from './ios.js'

let u = navigator.userAgent;
let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1;

class AppApi {
    api(iosObj, androidObj = iosObj) {

        return new Promise((resovle, reject) => {
            if (isAndroid) {
                window.WebViewJavascriptBridge.callHandler(
                    "NBDBridge",
                    androidObj,
                    function (res) {
                        console.log('----' + res)
                        if (res) {
                            resovle(res);
                        } else {
                            reject(res)
                        }

                    },
                );
                return;
            }
            Bridge.callHandler("NBDBridge", iosObj, function (res) {
                if (res) {
                    resovle(res);
                } else {
                    reject(res)
                }
            });
        }).catch(e => {});
    }

    // 获取token
    async getToken(isForce = false) {
        let iosObj = { operate: "login", isForce };
        let androidObj = { operate: "login", isForce };
        let res = await this.api(iosObj, androidObj);
        return res;
    }

    // 文章详情页跳转

    async openArticle(articleInfo) {
        let u = navigator.userAgent;


        if (u.search("nbd") != -1) {
            let obj = { operate: "open_article", ...articleInfo };
            let res = await this.api(obj);
            return res;
        } else {
            window.location.href = 'http://www.nbd.com.cn/corp/newArticle/index.html#/app_article/' + articleInfo.article_id
        }

    }

    // 返回
    async pop() {
        let obj = { operate: "pop" };
        let res = await this.api(obj);
        return res;
    }

    // 分享
    async share(shareInfo) {
        let obj = { operate: "share", ...shareInfo };
        let res = await this.api(obj);
        return res;
    }
    //搜索
    async search(shareInfo) {
        let obj = { operate: "search" };
        let res = await this.api(obj);
        return res;
    }
    // 跳转首页
    async jump_to_home(shareInfo) {
        let obj = { operate: " jump_to_home", home_index: 0 };
        let res = await this.api(obj);
        return res;
    }
    // app支付
    async app_pay(pay_params) {
        let obj = { operate: 'pay', ...pay_params }

        let res = await this.api(obj)
        return res
    }

    //app支付 IOS 牛币支付
    async purchaseGoods(pay_params) {
        let obj = { operate: 'purchaseGoods', ...pay_params }

        let res = await this.api(obj)
        return res
    }

    //跳转链接

    async open_link(params) {
        if (u.search("nbd") != -1) {
            let obj = { operate: 'open_link', ...params }
            let res = await this.api(obj)
            return res
        } else {
            window.location.href = params.url
        }
        
    }

    //自选 

    async addStock(codes) {
        let obj = { operate: "follow_stock", codes: codes };
        let res = await this.api(obj);
        return res;
    }

    //跳个股
    async turnStock(stockInfo) {
        let obj = { operate: "open_stock", ...stockInfo };
        let res = await this.api(obj);
        return res;
    }

    //导航栏 hide_action_bar:  hide_more
    async title_control(stockInfo) {
        let obj = { operate: "hide_title_bar", ...stockInfo };
        let res = await this.api(obj);
        return res;
    }

}


export default new AppApi()




